import script from "./GenericInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./GenericInfoModal.vue?vue&type=style&index=0&id=1c460883&lang=css"

const __exports__ = script;

export default __exports__